import AgentTreeComponent from './agent-tree';
export default AgentTreeComponent;
